
import Vue from 'vue'

import { Toast, Dialog, Swipe, SwipeItem, Tab, Tabs, Overlay, Loading } from 'vant'

Vue.prototype.Toast = Toast
Vue.prototype.Dialog = Dialog
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Overlay)
Vue.use(Loading)
